import styled from "styled-components/macro";

export const Container = styled.div`
  max-width: 96.5rem;
  margin: 0 auto;
`;
